import React from 'react'
import './projects.css'
import Webagencywebsite from './../../assets/projects/website-1.png'
import WordpressStrass from './../../assets/projects/website-2.png'
import Bikessels from './../../assets/projects/website-3.png'
import Ecrivwebsite from './../../assets/projects/website-4.png'
import HKwebsite from './../../assets/projects/website-5.png'
import Whalewebsite from './../../assets/projects/website-6.png'
import { useLanguage } from '../../context/LanguageContext'
import ScrollReveal from '../shared/ScrollReveal'


const Projects = () => {
  const { t } = useLanguage()

  return (
    <div className='projects__container'>
      <div className="container projects__container">
        <div className='projects__entete'>
          <h2 id="Projects" className='projects__entete--title'>{t.projects.title}</h2>
          <p className='projects__entete--text'>{t.projects.desc}</p>
        </div>
        <div className='projects__menu'>
          <div className="projects__menu--button">
            <div className="nav-item">
              <a href="#Projects">Plan</a>
            </div>
            {/* <div className="nav-item">
              <a href="#">Tab2</a>
            </div>
            <div className="nav-item">
              <a href="#">Tab3</a>
            </div> */}
          </div>
        </div>
        <div className="projects__menu--projectslist">
          <ScrollReveal delay={0} className='projects-item projects-item--featured'>
            <a href="https://www.whaleverse.cc/">
              <img src={ Whalewebsite } alt="Whaleverse.cc" />
              <div className="projects-txt">
                <h4>NFT Showcase</h4>
                <span>{t.projects.role}</span>
                <div className='projects-tags'><span className='projects-tag'>React</span><span className='projects-tag'>CSS</span></div>
              </div>
            </a>
          </ScrollReveal>
          <ScrollReveal delay={100} className='projects-item projects-item--hk'>
            <a href="https://hongkong.mezianesofiane.com/">
              <img src={ HKwebsite } alt="Hong Kong" />
              <div className="projects-txt">
                <h4>Hong Kong: photoweb</h4>
                <span>{t.projects.role}</span>
                <div className='projects-tags'><span className='projects-tag'>HTML</span><span className='projects-tag'>CSS</span><span className='projects-tag'>JS</span></div>
              </div>
            </a>
          </ScrollReveal>
          <ScrollReveal delay={200} className='projects-item projects-item--alaska'>
            <a href="https://alaskaproject.mezianesofiane.com/">
              <img src={ Ecrivwebsite } alt="Alaska" />
              <div className="projects-txt">
                <h4>Alaska essay</h4>
                <span>{t.projects.role}</span>
                <div className='projects-tags'><span className='projects-tag'>HTML</span><span className='projects-tag'>CSS</span><span className='projects-tag'>JS</span></div>
              </div>
            </a>
          </ScrollReveal>
          <ScrollReveal delay={100} className='projects-item projects-item--bike'>
            <a href="https://www.bikessels.mezianesofiane.com/">
              <img src={ Bikessels } alt="Bicycle rental" />
              <div className="projects-txt">
                <h4>Bicycle rental app</h4>
                <span>{t.projects.role}</span>
                <div className='projects-tags'><span className='projects-tag'>React</span><span className='projects-tag'>Node.js</span></div>
              </div>
            </a>
          </ScrollReveal>
          <ScrollReveal delay={200} className='projects-item projects-item--strass'>
            <a href="https://agence-strasbourg.mezianesofiane.com/">
              <img src={ WordpressStrass } alt="Tourisme Strasbourg" />
              <div className="projects-txt">
                <h4>Strasbourg tourist office</h4>
                <span>{t.projects.role}</span>
                <div className='projects-tags'><span className='projects-tag'>WordPress</span><span className='projects-tag'>PHP</span></div>
              </div>
            </a>
          </ScrollReveal>
          <ScrollReveal delay={300} className='projects-item projects-item--agency'>
            <a href="https://webagency.mezianesofiane.com/">
              <img src={ Webagencywebsite } alt="Web agency" />
              <div className="projects-txt">
                <h4>Web Integration</h4>
                <span>{t.projects.role}</span>
                <div className='projects-tags'><span className='projects-tag'>HTML</span><span className='projects-tag'>CSS</span><span className='projects-tag'>JS</span></div>
              </div>
            </a>
          </ScrollReveal>
        </div>
      </div>
    </div>
  )
}

export default Projects